import axios from "axios";
import * as Constants from "../utils/constants";

// Function to set the Authorization header
export const setAuthToken = (token) => {
  if (token) {
    Constants.CONFIG.headers = {
      ...Constants.CONFIG.headers,
      Authorization: `Bearer ${token}`,
    };
  } else {
    delete Constants.CONFIG.headers["Authorization"];
  }
};

export const setting = async (fullName, gender, theme, language, country) => {
  try {
    const response = await axios.post(
      Constants.SETTING,
      {
        fullName: fullName,
        gender: gender,
        theme: theme,
        language: language,
        country: country,
      },
      Constants.CONFIG
    );
    if (response.status === 200) {
      return "success";
    } else if (response.status === 500) {
      return response.data;
    } else {
      return response.status;
    }
  } catch (error) {
    return "error";
  }
};

export const getSetting = async () => {
  try {
    const response = await axios.get(Constants.SETTING, Constants.CONFIG);
    if (response.status === 200) {
      return response.data;
    } else if (response.status === 500) {
      return response.data;
    } else {
      return response.status;
    }
  } catch (error) {
    return error;
  }
};
